export default {
  nome: {
    value: null,
    required: true,
    maxlength: 200,
    state: null
  },
  alertaGrupoID: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  mensagem: {
    value: null,
    required: true,
    maxlength: 200,
    state: null
  },
  travaEdicao: {
    value: false,
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/pci/items/addValidation-form.js